<template>
  <section class="h-full px-4 pb-8 gap-6 overflow-hidden grid grid-rows-[auto_auto_1fr] mb-4">
    <h2 class="text-lg font-medium text-gray-800">{{ $t('pages.installation') }}</h2>

    <nav
      role="section-nav"
      class="flex justify-between text-sm text-center border-b sm:px-0 min-h-9">
      <ul class="flex flex-wrap items-center gap-4 -mb-px">
        <li
          v-for="tab in detailsTabs"
          :key="tab.name"
          @click="selectedDetailsTab = tab.name"
          class="py-1.5 cursor-pointer"
          :class="
            selectedDetailsTab === tab.name
              ? 'border-b-2 border-theme-500  text-gray-800 '
              : 'text-gray-400'
          ">
          <p>
            {{ tab.label }}
          </p>
        </li>
      </ul>
    </nav>
    <div class="h-full space-y-6 overflow-y-auto">
      <InstallationWorkOffline v-if="currentDetailsComponent?.name == 'workOffline'" />
      <InstallationRequiresVisits v-if="currentDetailsComponent?.name == 'requiresVisits'" />
      <InstallationAppModules v-if="currentDetailsComponent?.name == 'appsModules'" />
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import InstallationWorkOffline from './InstallationWorkOffline.vue';
import InstallationRequiresVisits from './InstallationRequiresVisits.vue';
import InstallationAppModules from './InstallationAppModules.vue';
import { useI18n } from 'vue-i18n';
import { useLookupsStore } from '@/stores/lookups';

const { t: $t } = useI18n({ useScope: 'global' });
const selectedDetailsTab = ref('appsModules');
const detailsTabs = ref([
  {
    name: 'appsModules',
    label: `${$t('settings.appsModules')}`,
  },
  {
    name: 'workOffline',
    label: `${$t('settings.workOffline')}`,
  },
  {
    name: 'requiresVisits',
    label: `${$t('settings.requiresVisits')}`,
  },
]);

const currentDetailsComponent = computed(() => {
  const selected = detailsTabs.value.find((tab) => tab.name === selectedDetailsTab.value);
  return selected ? selected : null;
});

const { getMwApplicationLookup, getMwModulesLookup } = useLookupsStore();

onMounted(async () => {
  await getMwApplicationLookup();
  await getMwModulesLookup();
});
</script>
